module.exports = __webpack_public_path__ + "static/media/whatsappcontorno.68563179.svg";